export interface ICourse {
    id: number;
    name: string;
    activeUntilDate?: Date;
    code?: string;
}

const newCourse = (): ICourse => ({
    id: 0,
    name: '',
})

export const createCourse = <T extends Partial<ICourse>>(initialValues: T): ICourse & T => {
    return Object.assign(newCourse(), initialValues);
};